import Card from "./card"

const FeaturesIndex = (props: any) => {
  const items = props.featuresData.items

  if (!items) {
    return <></>
  }

  return (
    <div tw="max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative">
      <div tw="grid grid-cols-4 desktop:(grid-cols-12) gap-4 desktop:(gap-6)">
        <>
          {items.map((cardData: any, i: number) => (
            <div tw="col-span-4 tablet:(col-span-6)" key={i}>
              <Card {...cardData} />
            </div>
          ))}
        </>
      </div>
    </div>
  )
}

export default FeaturesIndex
